import config from "../../config/common";
import handleErrors from "./handleErrors";
import logger from "../logger";
import packageInfo from "../../../package.json";

const {
  api: {
    product: {
      search: { retries }
    }
  }
} = config;

let configureRequest, httpsAgent;

if (SERVER) {
  ({ configureRequest } = require("@asosteam/asos-web-base-server"));

  const agentkeepalive = require("agentkeepalive");

  const {
    api: {
      keepAlive: { freeSocketTimeout, inactiveSocketTimeout }
    }
  } = config;

  httpsAgent = new agentkeepalive.HttpsAgent({
    timeout: inactiveSocketTimeout,
    freeSocketTimeout
  });
} else {
  ({ configureRequest } = require("@asosteam/asos-web-request"));
}

const webRequest = configureRequest({
  client: {
    name: packageInfo.name,
    version: packageInfo.version
  },
  validateStatus: null,
  retries,
  httpsAgent,
  logger
});

export const request = (url, options, requestType, uuid) =>
  webRequest
    .get({ url, uuid, ...options, additionalLoggingParams: { requestType } })
    .then(handleErrors(requestType))
    .then(({ data }) => data);
